(function (Translator) {
    // es
    Translator.add("rate_list.rate.bg_kbcbank", "Tasa de KBC Bank", "EvpThemeBundle", "es");
    Translator.add("recaptcha.description", "Este mensaje est\u00e1 destinado a verificar si una persona est\u00e1 navegando y para evitar sistemas de comprobaci\u00f3n autom\u00e1tica", "EvpThemeBundle", "es");
    Translator.add("recaptcha.title", "\u00bfEres un robot?", "EvpThemeBundle", "es");
})(Translator);
